<template>
    <div class="clue">
        <!--跳线索-->
        <div v-show="clueVisible" class="fix-pop cur-pointer" @click="popModal">
            <img src="../assets/images/index/pc-pop-btn.png" alt="">
        </div>

        <!--跳线索弹框-->
        <div class="modal" v-show="xiansuo">
            <div class="modal-box">
                <div class="modal-header">
                    <div class="modal-close cur-pointer" @click="modalClose1">
                        <img src="../assets/images/index/sponsor/icon-close.png" />
                    </div>
                </div>
                <div class="modal-body flex">
                    <div class="txt box">
                        <a :href="toClue1" target="_blank" @click="so_event('', 'clue_填写需求')" data-ignore="true">
                            <p><img src="../assets/images/index/txt-icon.png" alt=""></p>
                            <p>反馈需求</p>
                        </a>
                    </div>
                    <div class="online box" style="border-left: 1px solid #f1f1f1;">
                        <a :href="toClue2" target="_blank"  @click="so_event('', 'clue_在线咨询')" data-ignore="true">
                            <p><img src="../assets/images/index/online-icon.png" alt=""></p>
                            <p>产品&方案咨询</p>
                        </a>
                    </div>
                </div>
                <div class="modal-footer">会务咨询：<a href="tel://+86 0755-28565555">+86 0755-28565555</a></div>
            </div>
        </div>
    </div>
</template>

<script>
  import config from '../config'
  import so from '../utils/so_event'
    export default {
        name: "toClue",
        props: {
          visibilityHeight: {
            type: Number,
            default: 400
          },
        },
        data() {
          return {
            xiansuo: false,
            toClue1: config.toClue1, //线索地址
            toClue2: config.toClue2, //线索地址
            clueVisible: false
          }
        },
        mounted() {
            window.addEventListener('scroll', this.handleVisible)
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.handleVisible)
        },
        methods: {
          handleVisible() {
            this.clueVisible = window.pageYOffset > this.visibilityHeight
          },
          //弹出pop
          popModal() {
            this.xiansuo = true;
            this.so_event("","clue")
          },
          modalClose1() {
            this.xiansuo = false;
          },
            //so埋码事件
          so_event(page, module,item){
                so.so_click(page, module,item)
          }
        }
    }
</script>

<style lang="scss" scoped>
    /*跳线索*/
    .fix-pop{
        position: fixed;
        bottom: 160px;
        right: 0px;
        z-index: 5;
        img{
            width: 90px;
            height: 90px;
        }
    }

    /*弹窗*/
    .modal{
        position: fixed;
        top: 0;
        left: 0;
        right:0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,.6);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 999;
        .modal-box{
            position: relative;
            width: 360px;
            /*padding: 17px 26px 26px;*/
            box-sizing: border-box;
            /*background: #fff;*/
            .modal-close{
                position: absolute;
                width: 12px;
                height: 12px;
                top: 10px;
                right: 10px;
                cursor: pointer;
                img{
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                }
            }
            .modal-header{
                font-size: 20px;
                line-height: 38px;
                text-align: center;
                font-weight: bold;
                color: #555555;
                background-color: #fff;
            }
            .modal-body{
                padding-top: 12px;
                background-color: #fff;
                padding: 26px 26px;
                border-radius: 6px;
                font-size: 14px;
                .file-box{
                    border: 1px dashed rgba(170,170,170,.4);
                    padding: 15px 20px 17px 20px;
                    box-sizing: border-box;
                    .file-item{

                        display: flex;
                        align-items: center;
                        .file-icon{
                            flex: 0 0 30px!important;
                            width: 30px!important;
                            height: auto!important;
                        }
                        .file-title{
                            flex: 1;
                            margin-left: 10px;
                            display: flex;
                            flex-wrap: wrap;
                            font-size: 16px;
                            line-height: 31px;
                            color: #333333;
                        }
                    }
                }

                .input-box{
                    position: relative;
                    margin-top: 16px;
                    width: 100%;
                    height: 42px;
                    padding: 2px 0;
                    border: 1px solid #dddddd;
                    input{
                        border: 0;
                        outline: 0;
                        width: 100%;
                        box-sizing: border-box;
                        font-size: 14px;
                        font-weight: normal;
                        font-stretch: normal;
                        line-height: 38px;
                        height: 100%;
                        padding: 0 16px;
                        color: #aaaaaa;
                    }
                    .error{
                        color: red;
                        position: absolute;
                        bottom: -18px;
                        right: 0;
                        font-size: 14px;
                    }
                }

                .btn-box{
                    margin: 18px auto 0;
                    width: 158px;
                    height: 36px;
                    text-align: center;
                    line-height: 38px;
                    font-size: 16px;
                    color: #ffffff;
                    background-color: #5484e2;
                    box-shadow: 0px 1px 6.4px 0.6px
                    rgba(43, 8, 57, 0.06);
                    border-radius: 18px;
                }

                .success-box{
                    text-align: center;
                    margin-top: 31px;
                    .success-icon{
                        width: 82px;
                        height:82px;
                    }
                    p.success-tip{
                        margin-top: 8px;
                        font-size: 22px;
                        line-height: 38px;
                    }
                    .btn-box{
                        margin-top: 22px;
                    }
                }

                .box{
                    flex: 0 0 calc(50% - 40.5px);
                    width: calc(50% - 40.5px);
                    padding: 20px;
                    cursor: pointer;
                    text-align: center;
                    a{
                        color: #282828;
                    }
                    img{
                        margin-bottom: 10px;
                    }
                }

            }
            .modal-footer{
                background-color: #fff;
                border-radius: 6px;
                height: 50px;
                line-height: 50px;
                margin-top: 1px;
                color: $regularColor;
                font-size: 14px;
                font-weight: bolder;
                text-align: center;
                a{
                    color: $regularColor;
                }
            }

        }
        @media (max-width: 1230px){
            .modal-box{
                width: 38.39vw;
                /*height: 22.6vw;*/
                /*padding: 1.38vw 2.11vw 2.11vw;*/
                .modal-close{
                    position: absolute;
                    width: 0.98vw;
                    height: 0.98vw;
                    top: .81vw;
                    right: .81vw;
                }
                .modal-header{
                    font-size: 1.63vw;
                    line-height: 3.09vw;
                }
                .modal-body{
                    padding-top: .9vw;
                    padding: 2.11vw 2.11vw;
                    .file-box{
                        padding: 1.22vw 1.63vw 1.38vw;
                        .file-item{
                            .file-icon{
                                flex: 0 0 2.44vw!important;
                                width: 2.44vw!important;
                            }
                            .file-title{
                                margin-left: .81vw;
                                font-size: 1.3vw;
                                line-height: 2.52vw;
                            }
                        }
                    }

                    .input-box{
                        margin-top: 1.38vw;
                        height: 3.09vw;
                        input{
                            font-size: 1.14vw;
                            line-height: 3.09vw;
                            padding: 0 1.46vw;
                        }
                    }

                    .btn-box{
                        margin: 1.54vw auto 0;
                        font-size: 1.3vw;
                        line-height: 3.09vw;
                        width: 12.85vw;
                        height: 2.93vw;
                        box-shadow: 0vw 0.08vw 0.52vw 0.05vw
                        rgba(43, 8, 57, 0.06);
                        border-radius: 1.46vw;
                    }

                    .success-box{
                        padding-bottom: 1.47vw;
                        margin-top: 3vw;
                        .success-icon{
                            width: 6.67vw;
                            height:6.67vw;
                        }
                        p.success-tip{
                            margin-top: .65vw;
                            font-size: 1.79vw;
                            line-height: 3.09vw;
                        }
                        .btn-box{
                            margin-top: 1.79vw;
                        }
                    }

                }
            }
        }
        @media (max-width: 767px){
            .modal-box{
                width: 78vw;
                /*padding: 5.33vw;*/
                .modal-close{
                    width: 3.2vw;
                    height: 3.2vw;
                    top: 2.67vw;
                    right: 2.27vw;
                }
                .modal-header{
                    font-size: 4.27vw;
                    line-height: 5.07vw;
                }
                .modal-body{
                    padding-top: 5.07vw;
                    padding: 5.33vw;
                    border-radius: 0.06rem;
                    font-size: 0.24rem;
                    .file-box{
                        padding: 3.2vw 3.73vw 3.47vw;
                        .file-item{
                            .file-icon{
                                flex: 0 0 6.13vw!important;
                                width: 6.13vw!important;
                            }
                            .file-title{
                                margin-left: 2.4vw;
                                font-size: 3.47vw;
                                line-height: 4.13vw;
                            }
                        }
                    }

                    .input-box{
                        margin-top: 1.38vw;
                        height: 10.4vw;
                        input{
                            font-size: 3.2vw;
                            line-height: 5.07vw;
                            padding: 0 3.2vw;
                        }
                    }

                    .btn-box{
                        margin: 5.33vw auto 0;
                        font-size: 3.73vw;
                        line-height: 10.8vw;
                        width: 43.47vw;
                        height: 10.4vw;
                        box-shadow: 0vw 0.13vw 0.85vw 0.08vw
                        rgba(43, 8, 57, 0.06);
                        border-radius: 5.2vw;
                    }

                    .success-box{
                        text-align: center;
                        margin-top: 5.33vw;
                        .success-icon{
                            width: 21.6vw;
                            height:21.6vw;
                        }
                        p.success-tip{
                            margin-top: 3.6vw;
                            font-size: 4.27vw;
                            line-height: 5.87vw;
                        }
                        .btn-box{
                            margin-top: 6.27vw;
                        }
                    }

                    .box{
                        flex: 0 0 calc(49% - 0.6rem);
                        padding: 0.3rem;
                        cursor: pointer;
                        img{
                            margin-bottom: 0.1rem;
                        }
                    }
                }
                .modal-footer{
                    height: 0.8rem;
                    line-height: 0.8rem;
                    font-size: 0.24rem;
                    border-radius: 0.06rem;
                }
            }
        }
    }

    /*media 1840*/
    @media screen and (max-width: 1840px) {
        /*跳线索*/
        .fix-pop{
            img{
                width: 90px;
                height: 90px;
            }
        }
    }

    /*media 1420*/
    @media screen and (max-width: 1420px) {
        /*跳线索*/
        .fix-pop{
            bottom: 200px;
            img{
                width: 60px;
                height: 60px;
            }
        }
    }

    @media screen and (max-width: 750px) {
        /*跳线索*/
        .fix-pop{
            bottom: 2.3rem;
            right: 0.3rem;
            img{
                width: 1.29rem;
                height: 1.29rem;
            }
        }
    }
</style>
